
export type GetUserStats500 = {
  error?: string;
  message?: string;
  timestamp?: string;
};
